module.exports = __webpack_public_path__ + "img/5-1.a0f7fef6.png";